const frCreateFile: Record<string, { message: string; description: string }> = {
  "ledgerEditor.nameYourFile": {
    message: "Nommez votre fichier...",
    description: "Placeholder for file name input",
  },
};

export default frCreateFile;
